import React, { useState } from "react";
import EtapesTodosConfigForm from "./EtapesTodosConfigForm";
import styles from "./EnveloppeTable.module.scss";

/**
 * Gabarit étapes actives / todos par défaut du financeur : hérité par
 * toutes ses enveloppes tant qu'elles ne le surchargent pas explicitement
 * (EnveloppeConfigPanel) ou ne sont pas verrouillées (première demande
 * hors Brouillon), qui les détache définitivement de ce gabarit.
 *
 * Props :
 * - financeurConfig : { etapesActives, todos }
 * - onModifierEtapes(etapesActives) / onSynchroniserTodos(todos) : Promise<bool>
 */
const FinanceurConfigPanel = ({
  financeurConfig,
  onModifierEtapes,
  onSynchroniserTodos,
}) => {
  const [open, setOpen] = useState(false);

  return (
    <div className={styles.configPanel}>
      <button
        type="button"
        className={styles.btnCancel}
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
      >
        <i className={`fa fa-chevron-${open ? "down" : "right"}`} />{" "}
        Configuration par défaut (étapes et todos hérités par les nouvelles
        enveloppes)
      </button>
      {open && (
        <EtapesTodosConfigForm
          etapesActives={financeurConfig.etapesActives}
          todos={financeurConfig.todos}
          onSaveEtapes={onModifierEtapes}
          onSaveTodos={onSynchroniserTodos}
        />
      )}
    </div>
  );
};

export default FinanceurConfigPanel;
